import React, {useEffect, useState} from "react";
import {Col} from "antd";
import _ from "lodash";
import {
    DateFilter,
    PoolCourierFilter,
    PoolFilter
} from "../../../_defaultComponents/FilterComponents";

import {useHistory} from "react-router-dom";
import moment from "moment";
const Filters = ({setCurrentPage, filters, setFilters}) => {
    const history = useHistory();
    const [poolId, setPoolId] = useState(filters.pool);

    const handleUrlSearchParam = () => {
        const urlSearchParams = new URLSearchParams(history.location.search);
        const urlPoolId = urlSearchParams.get("poolId");
        if (urlPoolId) {
            setPoolId(urlPoolId);
        }
    };

    const setUrl = () => {
        let path = history?.location?.pathname;
        path += "?";

        if (poolId) {
            path += "poolId=" + poolId;
        }

        history.push(path);
    };

    useEffect(() => {
        const newFilters = {poolId};
        if (JSON.stringify(filters) !== JSON.stringify(newFilters)) {
            setFilters(newFilters);
            setUrl();
        }

        setCurrentPage(1);
    }, [poolId]);

    useEffect(() => {
        handleUrlSearchParam();
    }, []);

    return (
        <React.Fragment>
            <Col xs={20} sm={10} md={6} lg={6} xl={6}>
                <PoolFilter
                    value={poolId}
                    onChange={setPoolId}
                    showAllOption={false}
                    allowClear={true}
                />
            </Col>
        </React.Fragment>
    );
};

export default Filters;
